import React, {
    type ReactElement,
    type ReactNode,
    createContext,
    useContext,
    useState,
} from 'react';

const BottomSheetPortalContext = createContext<HTMLElement | null>(null);

const BottomSheetPortalProvider = ({ children }: { children: ReactNode }): ReactElement => {
    const [container, setContainer] = useState<HTMLElement | null>(null);
    return (
        <BottomSheetPortalContext.Provider value={container}>
            <div ref={setContainer} />
            {children}
        </BottomSheetPortalContext.Provider>
    );
};

export const useBottomSheetPortal = (): HTMLElement | null => useContext(BottomSheetPortalContext);

export default BottomSheetPortalProvider;
